export default {

    "userMenu": {
        "user": "User",
        "login": "Login",
        "overrideUser": "Override User",
        "settings": "Settings",
        "revertUserOverride": "Revert User Override",
        "administration": "Administration",
        "logout": "Logout",

        "language": "Language",
        "help": "Help",
        
        "resetUserSettings": {
            "menu": "Reset user settings",
            "modalTitle": "Reset user settings",
            "modalMessage": "You are about to reset ALL your user data (recent queries, collections, alerts, preferences, etc.). Do you want to continue?",
            "modalConfirmButton": "Confirm",
            "successMessage": "Reset user settings succefully",
            "errorMessage": "Reset user settings failed"
        },

        "darkMode": "Dark mode",
        "darkModeOn": "Switch to light mode",
        "darkModeOff": "Switch to dark mode",

        "credit": "About Sinequa"
    },

    "editUserSettings": {
        "title": "Settings",
        "language": "UI Language",
        "pageSize": "Number of results per page",
        "email": "Email"
    }

};
